module.exports = __webpack_public_path__ + "static/media/tulum-default-image.d78f6d61.png";